import Button from '@components/Button';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';
import { useTranslation } from 'react-i18next';

import useGiftOrder from './hooks/useGiftOrder';

interface Props {
    giftItem: GiftItemRow;
    qty: number;
    giftCardImageId?: string;
    agreed: boolean;
}

function Footer({
    giftItem, qty, giftCardImageId, agreed,
}: Props) {
    const {
        handleOrder, enabled, state, isPending,
    } = useGiftOrder(giftItem, qty, giftCardImageId);
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();
    const amount = giftItem.salePrice * qty * state.giftRecipients.length;

    return (
        <Button fullWidth type='button' disabled={!enabled || isPending || !agreed} onClick={handleOrder}>
            {t('giftOrder.payButton', {
                amount: amount.toLocaleString(),
                unit: priceUnit,
            })}
        </Button>
    );
}

export default Footer;
